import { useState, useEffect } from 'react';
import API_KEY from './Keys';

const CONTEXT_KEY = 'c6472f99d669348ad';

function useGoogleSearch(term) {
  /* custom hook */
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(
        `https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${term}`
      );
      const results = await response.json();
      setData(results);
    }

    fetchData();
  }, [term]);

  return { data };
}

export default useGoogleSearch;

{
  /* <script async src="https://cse.google.com/cse.js?cx=c6472f99d669348ad">
</script>
<div class="gcse-search"></div> */
}
